import React from 'react';

import { Container, StyledCheck, Icon } from './styles';

export interface Props {
  id?: string;
  checked: boolean;
  children?: React.ReactNode;
  circle?: boolean;
  size?: number;
  className?: string;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  testId?: string;
}

const Checkbox = ({ id, checked, children, onChange, circle, size, disabled = false, className, testId }: Props) => (
  <Container className={className || ''} data-testid={testId}>
    <StyledCheck
      id={id}
      className="checkbox"
      circle={circle}
      size={size}
      checked={checked}
      $disabled={disabled}
      onClick={onChange && !disabled ? () => onChange(!checked) : () => {}}
    >
      {checked && (
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      )}
    </StyledCheck>
    {children}
  </Container>
);

export default Checkbox;
